// extracted by mini-css-extract-plugin
module.exports =  {"root":"L7u2urug3NE7S9JjVYWm","pill":"MGaHTcBK0dYfAHaKjRaH","bigNumber":"tHjYpLH8Aiq3jomGJdP6"};